// Sentry initialization should be imported first!
// eslint-disable-next-line simple-import-sort/imports
import './scripts/sentry';

import ReactDOM from 'react-dom/client';
import { getI18n } from 'react-i18next';

import { AppWrapper } from '@/app/ui/AppWrapper';

import { errorReload } from '@/shared/helpers/error-reload';
import { ErrorBoundary } from '@/shared/hocs/withErrorBoundary/ErrorBoundary/ErrorBoundary';
import { initApplication } from '@/app/scripts/init-application';
import { logErrorMini } from '@/shared/services/service-logger/lib/log-error-mini';
import { ErrorPage } from '@/shared/ui/error-page/ErrorPage';

import { TopAnalyzeSDK } from 'top-analyze-sdk';

import { setAnalyticsInstance } from '@/shared/hooks/use-ton-connect-analytics';

import '@/app/styles/normalize.scss';
import '@/app/styles/_ui-kit/index.scss';
import '@/app/styles/core.scss';

/**
 * When a new deployment occurs, the hosting service may delete the assets from previous deployments.
 * https://vitejs.dev/guide/build#load-error-handling
 */
window.addEventListener('vite:preloadError', (event) => {
  errorReload(
    event.payload ? JSON.stringify(event.payload) : 'Error during page load',
    3
  );
});

const renderApp = () => {
  const analytics = new TopAnalyzeSDK({
    appName: 'Playdeck',
    debug: true,
    onlyImportantClicks: true,
    apiToken: 'NS0Pk:YRB4Z5KUomLtX0cOMcs44BBaeWy96t4OA3eEXYBgUo',
  });

  // Устанавливаем экземпляр аналитики для использования в хуке
  setAnalyticsInstance(analytics);

  analytics.start();

  const rootElement = document.getElementById('root');

  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);

    initApplication()
      .then(() => {
        root.render(
          <ErrorBoundary t={getI18n().t}>
            <AppWrapper />
          </ErrorBoundary>
        );
      })
      .catch((err) => {
        root.render(<ErrorPage message={err.message} isReload />);
        void logErrorMini(err as Error, 'renderApp');
      })
      .finally(() => {
        const preloaderStyles = document.getElementById('preloader-styles');

        setTimeout(() => {
          if (preloaderStyles) preloaderStyles.remove();
        }, 1000);
      });
  }
};

renderApp();
